import { FaInstagram, FaTiktok, FaYoutube, FaXTwitter, FaFacebookF } from 'react-icons/fa6';
import './PlatformBadge.css';

export const PLATFORMS = [
  { id: 'instagram', label: 'Instagram', icon: FaInstagram },
  { id: 'tiktok', label: 'TikTok', icon: FaTiktok },
  { id: 'youtube', label: 'YouTube', icon: FaYoutube },
  { id: 'x', label: 'X', icon: FaXTwitter },
  { id: 'facebook', label: 'Facebook', icon: FaFacebookF },
];

export const getPlatform = (id) => PLATFORMS.find((p) => p.id === id);

const PlatformBadge = ({ platform, size = 'md', withLabel = false }) => {
  const p = getPlatform(platform);
  if (!p) return null;
  const Icon = p.icon;

  return (
    <span className={`platform-badge platform-${platform} platform-badge-${size}`}>
      <Icon />
      {withLabel && <span className="platform-badge-label">{p.label}</span>}
    </span>
  );
};

export default PlatformBadge;
